import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogService } from '@core/services/dialog.service';
import { NotificationService } from '@core/services/notification.service';
import { getSelectedDataSetId } from '@core/state/data-set/data-set.selectors';
import { environment } from '@environment/environment';
import { Store } from '@ngrx/store';
import { BASE_PATH, CodeService } from 'data';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-upload-codes',
  templateUrl: './upload-codes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./upload-codes.component.scss']
})
export class UploadCodesComponent implements OnInit {
  saving;
  data;
  basePath;
  uploaded = false;
  codeType;
  code;

  constructor(
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private store: Store<any>,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Inject(APP_BASE_HREF) private baseHref: string,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    public dialog: MatDialog,
    private router: Router,
    private codeService: CodeService
  ) {
    this.basePath = basePath;
    baseHref = environment.apiConfig.baseUrl;
    this.codeType = inputData.codeType;
    this.code = inputData.code;
  }

  private sub$: Subscription;
  url: string;
  dataSetId$ = this.store.select(getSelectedDataSetId).pipe(filter((cId) => !!cId));

  ngOnInit(): void {
    this.dataSetId$.pipe(take(1)).subscribe((dataSetId) => {
      const credential = this.codeService.configuration.lookupCredential('Bearer');
      const httpRequestHeaders: { [header: string]: string } = {
        DatasetId: dataSetId
      };
      if (credential) {
        httpRequestHeaders.Authorization = credential;
      }
      var uploadUrl = '';
      var httpRequestParams;
      if (this.codeType) {
        uploadUrl = `${environment.apiConfig.baseUrl}/api/v1/code/${this.codeType}/import`;
        httpRequestParams = { codeType: this.inputData.codeType };
      } else if (this.code) {
        uploadUrl = `${environment.apiConfig.baseUrl}/api/v1/${this.code}/import`;
      }
      this.data = {
        title: 'Select File to Upload',
        subTitle: 'Files should be in CSV format.',
        uploadUrl: uploadUrl,
        httpRequestHeaders: httpRequestHeaders,
        httpRequestParams: httpRequestParams,
        uploadAllLabel: 'Upload File',
        maxFiles: 1,
        allowedExtensions: ['csv']
      };
    });
  }

  uploadAction() {
    this.dialog.closeAll();
  }
}
